import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from '../../../images/StudyCalculatorImg.webp';
import SharedGPA4to5 from './SharedGPA4to5'
import SharedGPA5to4 from './SharedGPA5to4'
const TITLE = 'GPA Converter: 4.0 Scale to 5.0 Scale and Vice Versa';
const DESCRIPTION = "Convert GPA between 4.0 and 5.0 scales with ease. Our GPA converter tool helps you understand how your GPA translates from one scale to another. Find out how to convert GPA from 4.0 to 5.0 and vice versa accurately.";
const KEYWORDS = "GPA Converter, GPA Conversion, Convert GPA 4.0 to 5.0, Convert GPA 5.0 to 4.0, GPA Scale Converter";
const OG_URL = 'https://do-calculate.com/calculator/en/gpa4to5';
function GPA4() {
  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} IMAGE={imageUrl} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
        <div className="col-12 col-md-4">
          <img src={imageUrl} alt="GPA Converter" style={{ height: '300px', width: '300px' }} />
        </div>
        <div className='col-12 col-md-8'>
          <img src={imageUrl} alt="GPA Converter" style={{ height: '300px', width: '300px' }} />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Looking to convert your GPA between different scales? Our GPA converter tool makes it simple to switch between 4.0 and 5.0 scales, ensuring you get accurate results with just a few clicks. Whether you're a student needing to understand your GPA on a different scale, or you need to compare GPAs for academic purposes, our tool offers fast and reliable conversions. Easily calculate and compare your GPA values across both scales and make informed academic decisions today!
                </p>
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
              <div className="col">
                <SharedGPA4to5 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPA5to4 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.studyCalculators}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Conversion Table for Cumulative GPA from 4 to 5 and Vice Versa</h2></u>
                  <table >
                    <tbody>
                      <tr className='gpa-header'>
                        <th>4.0 Scale</th>
                        <th>5.0 Scale</th>
                      </tr>
                      <tr>
                        <td>3.97 ~ 4.0</td>
                        <td>4.95 ~ 5.00</td>
                      </tr>
                      <tr>
                        <td>3.92 ~ 3.96</td>
                        <td>4.90 ~ 4.94</td>
                      </tr>
                      <tr>
                        <td>3.88 ~ 3.91</td>
                        <td>4.84 ~ 4.89</td>
                      </tr>
                      <tr>
                        <td>3.84 ~ 3.87</td>
                        <td>4.79 ~ 4.83</td>
                      </tr>
                      <tr>
                        <td>3.80 ~ 3.83</td>
                        <td>4.73 ~ 4.78</td>
                      </tr>
                      <tr>
                        <td>3.75 ~ 3.79</td>
                        <td>4.68 ~ 4.72</td>
                      </tr>
                      <tr>
                        <td>3.71 ~ 3.74</td>
                        <td>4.62 ~ 4.67</td>
                      </tr>
                      <tr>
                        <td>3.67 ~ 3.70</td>
                        <td>4.57 ~ 4.61</td>
                      </tr>
                      <tr>
                        <td>3.62 ~ 3.66</td>
                        <td>4.51 ~ 4.56</td>
                      </tr>
                      <tr>
                        <td>3.58 ~ 3.61</td>
                        <td>4.45 ~ 4.50</td>
                      </tr>
                      <tr>
                        <td>3.49 ~ 3.57</td>
                        <td>4.34 ~ 4.44</td>
                      </tr>
                      <tr>
                        <td>3.41 ~ 3.48</td>
                        <td>4.23 ~ 4.33</td>
                      </tr>
                      <tr>
                        <td>3.32 ~ 3.40</td>
                        <td>4.12 ~ 4.22</td>
                      </tr>
                      <tr>
                        <td>3.24 ~ 3.31</td>
                        <td>4.01 ~ 4.11</td>
                      </tr>
                      <tr>
                        <td>3.15 ~ 3.23</td>
                        <td>3.90 ~ 4.00</td>
                      </tr>
                      <tr>
                        <td>3.07 ~ 3.14</td>
                        <td>3.79 ~ 3.89</td>
                      </tr>
                      <tr>
                        <td>2.98 ~ 3.06</td>
                        <td>3.68 ~ 3.78</td>
                      </tr>
                      <tr>
                        <td>2.90 ~ 2.97</td>
                        <td>3.57 ~ 3.67</td>
                      </tr>
                      <tr>
                        <td>2.81 ~ 2.89</td>
                        <td>3.45 ~ 3.56</td>
                      </tr>
                      <tr>
                        <td>2.72 ~ 2.80</td>
                        <td>3.34 ~ 3.44</td>
                      </tr>
                      <tr>
                        <td>2.64 ~ 2.71</td>
                        <td>3.23 ~ 3.33</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GPA4;
